export const USA_COUNTRY_CODE = "USA";
